// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { websiteHomePath } from "@outschool/routes";
import React from "react";
import { useLocation } from "react-router";

import RedirectWrapper from "../components/parentDashboardV2/components/RedirectWrapper";

export enum ViewType {
  Classes = "classes",
  Agenda = "agenda",
  Week = "week",
  Month = "month",
}
export enum TabType {
  Enrolled = "enrolled",
  Waitlisted = "waitlisted",
}

const ParentSchedulePageWrapper = () => {
  const { query } = useLocation();
  const { view, tab }: { view: ViewType; tab: TabType } = query;

  const redirectUrl =
    view === ViewType.Classes && tab
      ? `${websiteHomePath()}?tab=${tab}`
      : websiteHomePath();

  return <RedirectWrapper to={redirectUrl} />;
};

export default ParentSchedulePageWrapper;
